import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/apiClient";

export interface FooterSettings {
  about_visible: boolean;
  terms_visible: boolean;
  privacy_visible: boolean;
}

/**
 * 获取页脚配置
 */
export function useFooterSettings() {
  return useQuery<FooterSettings>({
    queryKey: ["footerSettings"],
    queryFn: async () => {
      return apiClient<FooterSettings>("/api/v1/site_settings/footer", {
        disableAutoToast: true,
      });
    },
    staleTime: 60 * 60 * 1000, // 1小时缓存
    gcTime: 24 * 60 * 60 * 1000, // 24小时垃圾回收
  });
}
